<ol
    [class.flex-wrap]="wrap"
    [class.column-display]="direction === 'column'"
    #badgeContainer
>
    <ng-container
        *ngFor="let badge of badges; let i = index; let last = last; trackBy: trackByFn"
    >
        <li
            [class.d-flex]="allowDragArrange"
            [@fadeInOut]
            class="badge"
            [class.badge-close-on-hover]="badge.dismissible || dismissible"
            [class.badge-outline]="badge.outline"
            [class.cursor-pointer]="allowActive"
            [class.dragged-badge]="draggedIndex === i"
            [class.badge-draggable]="allowDragArrange"
            [class.badge-pending]="badge.pending"
            [ngClass]="[
                'badge-' + (variant || badge.variant || 'info'),
                badge.size ? 'badge-' + badge.size : 'badge-md'
            ]"
            *ngIf="i < maxBadgeCount || useBadgeMaxCount === false"
            [style.--background]="badge.color || null"
            #badges
        >
            <span
                [draggable]="allowDragArrange"
                (dragstart)="onDragStart($event, i)"
                (dragover)="onDragOver($event, i)"
                *ngIf="allowDragArrange"
                class="drag-indicator px-2"
            >
                {{ i + 1 }}
            </span>
            <span
                (dragover)="onDragOver($event, i)"
                (click)="allowActive && toggleActiveState(i)"
                [matTooltip]="badge.title"
            >
                {{ badge.title }}
                <button
                    *ngIf="
                        badge.dismissible ||
                        (dismissible &&
                            !badge.pending &&
                            (addIndicatorState$ | async) === null)
                    "
                    type="button"
                    class="close"
                    aria-label="Delete"
                    (click)="delete(i)"
                ></button>
                <sb-pending-button-indicator
                    *ngIf="!!badge.pending || (last && pending === 'add')"
                    [state]="addIndicatorState$ | async"
                ></sb-pending-button-indicator>
            </span>
        </li>
    </ng-container>
    <button
        *ngIf="showAddButton"
        type="button"
        class="btn btn-secondary font-weight-bold sb-add-badge-btn text-nowrap d-inline-flex align-self-center"
        [class.px-0]="!showEnterNewBadge"
        style="min-width: 20px; border-width: 2px; min-height: 20px"
        [class.btn-sm]="size === 'sm'"
        [class.btn-lg]="size === 'lg'"
        [style.opacity]="showEnterNewBadge ? 1 : null"
    >
        <tabler-icon
            *ngIf="!showEnterNewBadge"
            (click)="addNewBadge()"
            [matTooltip]="'Add new'"
            name="plus"
            style="stroke-width: 3px"
            class="my-n1"
            [class.sb-icon-sm]="size === 'sm'"
            [class.sb-icon-md]="size === 'md'"
            [class.sb-icon-lg]="size === 'lg'"
        ></tabler-icon>
        <ng-container *ngIf="showEnterNewBadge">
            <span
                class="sb-add-badge my-n1 contenteditable"
                #newBadge
                [attr.contenteditable]="(addIndicatorState$ | async) !== 'loading'"
                [matAutocomplete]="auto"
                (blur)="
                    newBadgeCtrl.value.length === 0 ? (showEnterNewBadge = false) : null
                "
                (input)="newBadgeCtrl.setValue($event.target.innerText)"
                (keydown.enter)="addBadge(newBadgeCtrl.value, newBadge)"
                (keydown.escape)="showEnterNewBadge = false"
            ></span>
            <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="
                    newBadge.innerText = $event.option?.value;
                    newBadgeCtrl.setValue($event.option?.value);
                    window.getSelection().selectAllChildren(newBadge);
                    window.getSelection().collapseToEnd()
                "
                (optionActivated)="
                    newBadge.innerText = $event.option?.value;
                    newBadgeCtrl.setValue($event.option?.value);
                    window.getSelection().selectAllChildren(newBadge);
                    window.getSelection().collapseToEnd()
                "
            >
                <mat-option
                    *ngFor="let suggestion of suggestions$ | async"
                    (keydown.enter)="newBadge.innerText = $event.option.value"
                    (click)="
                        newBadge.innerText = suggestion;
                        newBadgeCtrl.setValue(suggestion);
                        window.getSelection().selectAllChildren(newBadge);
                        window.getSelection().collapseToEnd();
                        addBadge(newBadgeCtrl.value, newBadge);
                        showEnterNewBadge = false
                    "
                    [value]="suggestion"
                >
                    {{ suggestion }}
                </mat-option>
            </mat-autocomplete>
        </ng-container>
    </button>
    <span
        *ngIf="badges.length - maxBadgeCount > 0 && useBadgeMaxCount"
        class="badge badge-outline"
        [ngClass]="['badge-' + (variant || 'info'), 'badge-' + (size || 'md')]"
    >
        <button type="button" class="show-more-btn" (click)="showAll()">
            Show {{ badges.length - maxBadgeCount }} more
        </button>
    </span>
</ol>
